/* OH ✦ HELLO wishlist — built in, no app.
   Hearts on product cards + product page, a header count, and /pages/wishlist.
   Saves are kept in the shopper's browser (localStorage), so no login is needed.
   Also: suggestions as you type in the menu search box, and searches hide fully sold-out dresses. */
(function () {
  'use strict';

  var KEY = 'ohWishlist';
  var MAX = 100;
  var HIDE_PARAM = 'options[unavailable_products]';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.5l-1.2-1.1C5.4 14.6 2 11.5 2 7.8 2 4.8 4.4 2.5 7.4 2.5c1.7 0 3.3.8 4.6 2.1 1.3-1.3 2.9-2.1 4.6-2.1 3 0 5.4 2.3 5.4 5.3 0 3.7-3.4 6.8-8.8 11.6L12 20.5z"/></svg>';
  var CROSS = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (i) { return i && typeof i.h === 'string'; }) : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }
  function root() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function wishlistUrl() { return root() + 'pages/wishlist'; }

  /* Every search form and search link on the page hides fully sold-out dresses */
  function hideSoldOutInSearch() {
    var forms = document.querySelectorAll('form[action]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      var action = (f.getAttribute('action') || '').split('?')[0];
      if (!/\/search\/?$/.test(action)) continue;
      if (f.querySelector('input[name="' + HIDE_PARAM + '"]')) continue;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = HIDE_PARAM;
      input.value = 'hide';
      f.appendChild(input);
    }
    var links = document.querySelectorAll('a[href*="/search?"]');
    for (var j = 0; j < links.length; j++) {
      var href = links[j].getAttribute('href') || '';
      if (href.indexOf('unavailable_products') > -1) continue;
      links[j].setAttribute('href', href + '&options%5Bunavailable_products%5D=hide');
    }
  }

  /* Hearts on product cards (collection grids, recommendations, search) */
  function decorateCards() {
    var figures = document.querySelectorAll('product-card[handle] .product-card__figure');
    for (var i = 0; i < figures.length; i++) {
      var fig = figures[i];
      if (fig.querySelector('.oh-wish--card')) continue;
      var card = fig.closest('product-card');
      var handle = card.getAttribute('handle');
      if (!handle) continue;
      var titleEl = card.querySelector('.product-title');
      var name = titleEl ? titleEl.textContent.trim() : handle;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'oh-wish oh-wish--card';
      b.setAttribute('data-oh-wish', handle);
      b.setAttribute('data-name', name);
      b.setAttribute('data-label-on', 'Remove ' + name + ' from wishlist');
      b.setAttribute('data-label-off', 'Save ' + name + ' to wishlist');
      b.setAttribute('aria-label', 'Save ' + name + ' to wishlist');
      b.setAttribute('aria-pressed', 'false');
      b.innerHTML = HEART;
      fig.appendChild(b);
    }
  }

  /* Reflect saved state on every heart + the header count */
  function sync() {
    var list = read(), set = {};
    list.forEach(function (i) { set[i.h] = true; });
    var buttons = document.querySelectorAll('[data-oh-wish]');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      var on = !!set[b.getAttribute('data-oh-wish')];
      var pressed = on ? 'true' : 'false';
      if (b.getAttribute('aria-pressed') !== pressed) b.setAttribute('aria-pressed', pressed);
      var label = on ? b.getAttribute('data-label-on') : b.getAttribute('data-label-off');
      if (label && b.getAttribute('aria-label') !== label) b.setAttribute('aria-label', label);
    }
    var counts = document.querySelectorAll('[data-oh-wish-count]');
    for (var j = 0; j < counts.length; j++) {
      var n = String(list.length);
      if (counts[j].textContent !== n) counts[j].textContent = n;
      counts[j].hidden = list.length === 0;
    }
  }

  var toastEl, toastTimer;
  function toast(msg, showLink) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'oh-wish-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span>' + esc(msg) + '</span>' + (showLink ? '<a href="' + esc(wishlistUrl()) + '">View wishlist</a>' : '');
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2800);
  }

  /* Klaviyo: lets you build price-drop / low-stock / "still thinking?" flows for identified shoppers */
  function track(btn) {
    var handle = btn.getAttribute('data-oh-wish');
    var card = btn.closest('product-card');
    var cardImg = card && card.querySelector('img');
    var image = btn.getAttribute('data-image') || (cardImg && (cardImg.currentSrc || cardImg.src)) || '';
    if (image.indexOf('//') === 0) image = 'https:' + image;
    var props = {
      ProductName: btn.getAttribute('data-name') || handle,
      ProductHandle: handle,
      ProductID: btn.getAttribute('data-id') || '',
      URL: location.origin + root() + 'products/' + handle,
      ImageURL: image,
      Price: btn.getAttribute('data-price') || ''
    };
    try {
      if (window.klaviyo && typeof window.klaviyo.track === 'function') window.klaviyo.track('Added to Wishlist', props);
      else if (window._learnq) window._learnq.push(['track', 'Added to Wishlist', props]);
    } catch (e) {}
  }

  function toggle(btn) {
    var handle = btn.getAttribute('data-oh-wish');
    var list = read();
    var idx = -1;
    for (var i = 0; i < list.length; i++) { if (list[i].h === handle) { idx = i; break; } }
    if (idx > -1) {
      list.splice(idx, 1);
      write(list);
      toast('Removed from your wishlist', false);
    } else {
      list.unshift({ h: handle, t: Date.now() });
      write(list);
      toast('Saved to your wishlist', true);
      track(btn);
      btn.classList.remove('is-pop');
      void btn.offsetWidth;
      btn.classList.add('is-pop');
    }
    sync();
  }

  /* ---------- Wishlist page (/pages/wishlist) ---------- */
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }
  function img(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function sizeIndex(p) {
    var opts = p.options || [];
    for (var i = 0; i < opts.length; i++) {
      var n = typeof opts[i] === 'string' ? opts[i] : (opts[i] && opts[i].name) || '';
      if (/size/i.test(n)) return i;
    }
    return -1;
  }
  /* A real Shopify add-to-cart form, wrapped in the theme's <product-form> so the bag drawer opens as normal */
  function addForm(variant, label, cls, aria) {
    return '<product-form><form method="post" action="' + esc(root() + 'cart/add') + '" id="oh-wl-add-' + variant.id + '" accept-charset="UTF-8" enctype="multipart/form-data" class="oh-wl-form">' +
      '<input type="hidden" name="form_type" value="product">' +
      '<input type="hidden" name="utf8" value="✓">' +
      '<input type="hidden" name="id" value="' + variant.id + '">' +
      '<input type="hidden" name="quantity" value="1">' +
      '<input type="hidden" name="on_success" value="force_open_drawer">' +
      '<button type="submit" class="' + cls + '" aria-label="' + esc(aria) + '">' + esc(label) + '</button>' +
    '</form></product-form>';
  }
  function buyHtml(p, name, url) {
    var variants = p.variants || [];
    if (!p.available) {
      return '<p class="oh-wl-card__sub">Sold out</p><a class="oh-wl-card__cta" href="' + esc(url) + '">Get notified</a>';
    }
    var idx = sizeIndex(p);
    if (idx === -1 || variants.length <= 1) {
      var first = variants.filter(function (v) { return v.available; })[0];
      return first ? addForm(first, 'Add to bag', 'oh-wl-card__cta oh-wl-card__add', 'Add ' + name + ' to bag') : '';
    }
    var order = [], bySize = {};
    variants.forEach(function (v) {
      var s = (v.options && v.options[idx]) || v['option' + (idx + 1)];
      if (s == null) return;
      if (!bySize[s]) { bySize[s] = v; order.push(s); }
      else if (!bySize[s].available && v.available) bySize[s] = v;
    });
    var sizes = order.map(function (s) {
      var v = bySize[s];
      if (v.available) return addForm(v, s, 'oh-wl-size', 'Add ' + name + ' in size ' + s + ' to bag');
      return '<a class="oh-wl-size is-sold" href="' + esc(url + '?variant=' + v.id) + '" aria-label="Size ' + esc(s) + ' sold out — get notified when it is back">' + esc(s) + '</a>';
    }).join('');
    return '<p class="oh-wl-card__hint">Tap a size to add to bag</p><div class="oh-wl-sizes">' + sizes + '</div>';
  }
  function cardHtml(p) {
    var parts = String(p.title).split(' | ');
    var url = root() + 'products/' + p.handle;
    var price = '<span>' + esc(money(p.price)) + '</span>';
    if (p.compare_at_price && p.compare_at_price > p.price) price += ' <s class="oh-wl-card__was">' + esc(money(p.compare_at_price)) + '</s>';
    return '<article class="oh-wl-card">' +
      '<a class="oh-wl-card__media" href="' + esc(url) + '">' +
        (p.featured_image ? '<img src="' + esc(img(p.featured_image, 600)) + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="900">' : '') +
      '</a>' +
      '<button type="button" class="oh-wl-card__remove" data-oh-wish-remove="' + esc(p.handle) + '" aria-label="Remove ' + esc(parts[0]) + ' from wishlist">' + CROSS + '</button>' +
      '<div class="oh-wl-card__info">' +
        '<a class="oh-wl-card__title" href="' + esc(url) + '">' + esc(parts[0]) + '</a>' +
        (parts[1] ? '<p class="oh-wl-card__sub">' + esc(parts[1]) + '</p>' : '') +
        '<p class="oh-wl-card__price">' + price + '</p>' +
        buyHtml(p, parts[0], url) +
      '</div>' +
    '</article>';
  }
  function updatePageCount() {
    var n = read().length;
    var countEl = document.querySelector('[data-oh-wl-count]');
    if (countEl) countEl.textContent = n === 1 ? '1 item' : n + ' items';
    var empty = document.querySelector('[data-oh-wl-empty]');
    if (empty) empty.hidden = n > 0;
  }
  function renderPage() {
    var grid = document.querySelector('[data-oh-wl-grid]');
    if (!grid) return;
    var list = read();
    updatePageCount();
    if (!list.length) { grid.innerHTML = ''; return; }
    grid.setAttribute('aria-busy', 'true');
    Promise.all(list.map(function (i) {
      return fetch(root() + 'products/' + encodeURIComponent(i.h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (r.status === 404) return { missing: i.h };
          return r.ok ? r.json() : null;
        })
        .catch(function () { return null; });
    })).then(function (res) {
      var gone = res.filter(function (p) { return p && p.missing; }).map(function (p) { return p.missing; });
      if (gone.length) {
        write(read().filter(function (i) { return gone.indexOf(i.h) === -1; }));
        sync();
      }
      grid.innerHTML = res.filter(function (p) { return p && !p.missing; }).map(cardHtml).join('');
      grid.removeAttribute('aria-busy');
      updatePageCount();
    });
  }

  /* ---------- Suggestions as you type in the menu search box ---------- */
  function searchUrl(q) { return root() + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=hide'; }
  function initMenuSuggest() {
    var input = document.getElementById('oh-menu-search-input');
    if (!input || input.getAttribute('data-oh-suggest')) return;
    input.setAttribute('data-oh-suggest', '1');
    var form = input.closest('form');
    var box = document.createElement('div');
    box.className = 'oh-suggest';
    box.id = 'oh-menu-suggest';
    box.hidden = true;
    box.setAttribute('aria-live', 'polite');
    input.setAttribute('aria-controls', 'oh-menu-suggest');
    input.setAttribute('aria-autocomplete', 'list');
    (form || input).insertAdjacentElement('afterend', box);

    var timer, ctrl;
    function clear() { box.hidden = true; box.innerHTML = ''; }
    function priceText(p) {
      var v = parseFloat(p.price);
      return isNaN(v) ? '' : money(Math.round(v * 100));
    }
    function run(q) {
      if (ctrl) { try { ctrl.abort(); } catch (e) {} }
      ctrl = window.AbortController ? new AbortController() : null;
      var url = root() + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources%5Btype%5D=query,collection,product&resources%5Blimit%5D=6&resources%5Blimit_scope%5D=each' +
        '&resources%5Boptions%5D%5Bunavailable_products%5D=hide';
      fetch(url, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || input.value.trim() !== q) return;
          var res = (d.resources && d.resources.results) || {};
          var queries = (res.queries || []).slice(0, 5);
          var cols = (res.collections || []).slice(0, 3);
          var prods = (res.products || []).filter(function (p) { return p.available !== false; }).slice(0, 4);
          var html = '';
          if (queries.length) {
            html += '<p class="oh-suggest__label">Suggestions</p><ul class="oh-suggest__list" role="list">' +
              queries.map(function (s) { return '<li><a class="oh-suggest__query" href="' + esc(searchUrl(s.text)) + '">' + esc(s.text) + '</a></li>'; }).join('') +
              '</ul>';
          }
          if (cols.length) {
            html += '<p class="oh-suggest__label">Categories</p><ul class="oh-suggest__list" role="list">' +
              cols.map(function (c) { return '<li><a class="oh-suggest__query" href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>'; }).join('') +
              '</ul>';
          }
          if (prods.length) {
            html += '<p class="oh-suggest__label">Dresses</p><ul class="oh-suggest__list" role="list">' +
              prods.map(function (p) {
                var image = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
                return '<li><a class="oh-suggest__product" href="' + esc(p.url) + '">' +
                  (image ? '<img src="' + esc(img(image, 120)) + '" alt="" width="44" height="60" loading="lazy">' : '<span class="oh-suggest__noimg"></span>') +
                  '<span class="oh-suggest__pinfo"><span class="oh-suggest__ptitle">' + esc(String(p.title).split(' | ')[0]) + '</span>' +
                  '<span class="oh-suggest__pprice">' + esc(priceText(p)) + '</span></span>' +
                '</a></li>';
              }).join('') +
              '</ul>';
          }
          if (!html) html = '<p class="oh-suggest__empty">No matches yet — keep typing or try another word.</p>';
          html += '<a class="oh-suggest__all" href="' + esc(searchUrl(q)) + '">See all results for “' + esc(q) + '”</a>';
          box.innerHTML = html;
          box.hidden = false;
        })
        .catch(function () {});
    }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { clear(); return; }
      timer = setTimeout(function () { run(q); }, 180);
    });
    input.addEventListener('search', function () { if (!input.value.trim()) clear(); });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-oh-wish-remove]');
    if (rm) {
      e.preventDefault();
      var h = rm.getAttribute('data-oh-wish-remove');
      write(read().filter(function (i) { return i.h !== h; }));
      var card = rm.closest('.oh-wl-card');
      if (card) card.remove();
      sync();
      updatePageCount();
      return;
    }
    var b = e.target.closest('[data-oh-wish]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(b);
  });

  var queued = false;
  function refresh() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; decorateCards(); sync(); hideSoldOutInSearch(); });
  }

  function init() {
    decorateCards();
    sync();
    hideSoldOutInSearch();
    renderPage();
    initMenuSuggest();
    /* Cards and forms added later (filters, infinite scroll, quick view, recommendations, search drawer) */
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) { refresh(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
